import React, { useMemo, useState } from "react";
import GridTable from "../../constant/GridTable";
import { exchangeType, parseDate } from "../../constant/enum";
import moment from "moment";

function PositionHistory({ positionHistory }) {
  const [colDefs] = useState([
    {
      headerName: "Sr.No.",
      field: "id",
      valueGetter: "node.rowIndex + 1",
      sortable: true,
      filter: "agNumberColumnFilter",
    },
    {
      headerName: "Status",
      field: "status",
      sortable: true,
      filter: "agTextColumnFilter",
      cellRenderer: "agGroupCellRenderer",
    },
    {
      headerName: "Quantity",
      field: "quantity",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Remaining Quantity",
      field: "remaining_quantity",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Exchange",
      field: "exchange_type",
      sortable: true,
      cellRenderer: (params) => {
        return (
          <>
            {
              exchangeType.filter(
                (list) => list.value == params.data.exchange_type
              )[0]?.key
            }
          </>
        );
      },
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Symbol",
      field: "symbol",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Position Side",
      field: "position_side",
      sortable: true,
      filter: "agTextColumnFilter",
    },

    {
      headerName: "Average Price",
      field: "entry_price",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Total Realized Pnl",
      field: "total_realized_pnl",
      sortable: true,
      filter: "agTextColumnFilter",
    },

    {
      headerName: "Date",
      field: "createdAt",
      cellRenderer: (params) => {
        return <>{moment(params.value).format("lll")}</>;
      },
      sortable: true,
      filter: "agDateColumnFilter",
      filterParams: {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
          const cellDate = parseDate(cellValue);
          if (!cellDate) {
            return -1;
          }
          if (cellDate.getTime() === filterLocalDateAtMidnight.getTime()) {
            return 0;
          }
          return cellDate < filterLocalDateAtMidnight ? -1 : 1;
        },
      },
    },
  ]);
  const detailCellRendererParams = useMemo(() => {
    return {
      detailGridOptions: {
        rowSelection: { mode: "multiRow", headerCheckbox: false },
        pagination: true,
        paginationAutoPageSize: true,
        columnDefs: [
          { field: "close_quantity" },
          { field: "close_price" },
          { field: "realized_pnl" },
          {
            field: "createdAt",
            cellRenderer: (params) => {
              return <>{moment(params.value).format("lll")}</>;
            },
          },
        ],
        defaultColDef: {
          flex: 1,
        },
      },
      getDetailRowData: (params) => {
        params.successCallback(params?.data?.children);
      },
    };
  }, []);

  const rowClassRules = useMemo(() => {
    return {
      "sick-days-warning": "data.position_side =='SHORT'",
      "sick-days-breach": "data.position_side =='LONG'",
    };
  }, []);

  return (
    <div className=" ">
      <h4 className="trade_history">Position History</h4>
      <div>
        <GridTable
          data={positionHistory}
          colDefs={colDefs}
          height="100vh"
          detailCellRendererParams={detailCellRendererParams}
          rowClassRules={rowClassRules}
        />
      </div>
    </div>
  );
}

export default PositionHistory;
